import React from 'react'
import Picker from '../common/Picker'

const CurrencyPicker = (props) => {

    const option = (currency) => <span>{currency}</span>

    return (
        <Picker
            {...props}
            option={option}
        />
    )
}

export default CurrencyPicker